import { createActionNamespace } from 'edp-redux-tools';

const { addActions } = createActionNamespace('[global]');

export default addActions({
  ADD_FETCH: ['data'],
  FETCH_RESOURCE_FAIL: ['error'],
  NO_OP: [],
  REMOVE_FETCH: ['data']
});
